export default __webpack_public_path__ + "static/media/archi_view3.1e72d8de.webp";